/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';

import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import TextField from '@common_textfield';
import Autocomplete from '@common_autocomplete';
import IcubeMapsAutocomplete from '@common_googlemaps_autocomplete';

import useStyles from '@sellermodules/register/pages/default/components/stepform/style';
import DropFile from '@sellermodules/register/pages/default/components/dropfile';

const RegisterSeller = (props) => {
    const classes = useStyles();
    const {
        formik, getCountry, getCountryRes, getCountries, getCountriesRes,
        getCityKecByRegionCode, getCityKecByRegionCodeRes, t, handleDropFile,
        gmapKey, enableMap, mapPosition, handleDragPosition, geocodingKey,
        recaptcha, sitekey, onReCAPTCHAChange, recaptchaRef, termAgree, setTermAgree,
        isEnableTaxPayer, isEnableID, setValidationAddress, createStore,
    } = props;

    const [isRequired, setIsRequired] = useState({
        region: true,
        city: true,
    });

    useEffect(() => {
        getCountry({ variables: { id: formik.values.countries && formik.values.countries.id } });
    }, []);

    useEffect(() => {
        setIsRequired({
            region: true,
            city: true,
        });
        setValidationAddress({
            region: createStore && Yup.object().typeError(t('registerseller:This_is_a_Required_field'))
                .required(t('registerseller:This_is_a_Required_field')),
            city: createStore && Yup.object().typeError(t('registerseller:This_is_a_Required_field'))
                .required(t('registerseller:This_is_a_Required_field')),
            countries: createStore && Yup.object().typeError(t('registerseller:This_is_a_Required_field'))
                .required(t('registerseller:This_is_a_Required_field')),
        });
        if (!getCountryRes?.data?.country?.available_regions?.length) {
            setIsRequired({
                region: false,
                city: false,
            });
            setValidationAddress((prev) => ({
                ...prev,
                region: Yup.object().nullable(),
                city: Yup.object().nullable(),
            }));
        }
        if (!getCityKecByRegionCodeRes?.data?.getCityKecByRegionCode?.length) {
            setIsRequired((prev) => ({
                ...prev,
                city: false,
            }));
            setValidationAddress((prev) => ({
                ...prev,
                city: Yup.object().nullable(),
            }));
        }
    }, [getCountryRes.data, getCityKecByRegionCodeRes.data]);

    return (
        <>
            <div className={clsx('col-xs-12 col-sm-12', classes.formField)}>
                <InputLabel htmlFor="store_name" className={[classes.label, classes.required]}>
                    {t('registerseller:Store_Name')}
                </InputLabel>
                <TextField
                    id="store_name"
                    name="store_name"
                    value={formik.values.store_name}
                    onChange={formik.handleChange}
                    className={classes.textInput}
                    error={!!(formik.touched.store_name && formik.errors.store_name)}
                    helperText={(formik.touched.store_name && formik.errors.store_name) || ''}
                />
            </div>
            <div className={clsx('col-xs-12 col-sm-12', classes.formField)}>
                <InputLabel htmlFor="street" className={[classes.label, classes.required]}>
                    {t('registerseller:Store_Address')}
                </InputLabel>
                <TextField
                    id="street"
                    name="street"
                    value={formik.values.street}
                    onChange={formik.handleChange}
                    className={classes.textInput}
                    error={!!(formik.touched.street && formik.errors.street)}
                    helperText={(formik.touched.street && formik.errors.street) || ''}
                />
            </div>
            <div className={clsx('col-xs-12 col-sm-12', classes.formField)}>
                <InputLabel htmlFor="countries" className={[classes.label, classes.required]}>
                    {t('registervendor:Country')}
                </InputLabel>
                <Autocomplete
                    id="countries"
                    name="countries"
                    mode="lazy"
                    getOptions={getCountries}
                    value={formik.values.countries}
                    onChange={(e) => {
                        formik.setFieldValue('countries', e);
                        formik.setFieldValue('region', null);
                        formik.setFieldValue('city', null);
                        getCountry({
                            variables: {
                                id: e?.id,
                            },
                        });
                    }}
                    options={(getCountriesRes && getCountriesRes.data && getCountriesRes.data.countries)
                        || []}
                    loading={getCountriesRes.loading}
                    primaryKey="id"
                    labelKey="full_name_english"
                    fullWidth
                    renderInput={(params) => (
                        <TextField
                            value={formik.values.countries}
                            className={classes.textInput}
                            error={!!(formik.touched.countries && formik.errors.countries)}
                            helperText={(formik.touched.countries && formik.errors.countries) || ''}
                            {...params}
                        />
                    )}
                    disableClearable
                />
            </div>
            <div className={clsx('col-xs-12 col-sm-12', classes.formField)}>
                <InputLabel htmlFor="region" className={[classes.label, isRequired.region && classes.required]}>
                    {t('registerseller:Province')}
                </InputLabel>
                <Autocomplete
                    disabled={!(formik.values.countries && formik.values.countries.id)}
                    id="region"
                    name="region"
                    mode="lazy"
                    getOptions={getCountry}
                    getOptionsVariables={{ variables: { id: formik.values.countries?.id } }}
                    value={formik.values.region}
                    onChange={(e) => {
                        formik.setFieldValue('region', e);
                        formik.setFieldValue('city', null);
                        getCityKecByRegionCode({
                            variables: {
                                region_code: e?.code,
                            },
                        });
                    }}
                    options={(getCountryRes && getCountryRes.data
                        && getCountryRes.data.country && getCountryRes.data.country.available_regions)
                        || []}
                    loading={getCountryRes.loading}
                    primaryKey="id"
                    labelKey="name"
                    fullWidth
                    renderInput={(params) => (
                        <TextField
                            value={formik.values.region}
                            className={classes.textInput}
                            error={!!(formik.touched.region && formik.errors.region)}
                            helperText={(formik.touched.region && formik.errors.region) || ''}
                            {...params}
                        />
                    )}
                    disableClearable
                />
            </div>
            <div className={clsx('col-xs-12 col-sm-12', classes.formField)}>
                <InputLabel htmlFor="city" className={[classes.label, isRequired.city && classes.required]}>
                    {t('registerseller:City')}
                </InputLabel>
                <Autocomplete
                    disabled={!(formik.values.region && formik.values.region.id)}
                    id="city"
                    name="city"
                    mode="lazy"
                    getOptions={getCityKecByRegionCode}
                    getOptionsVariables={{ variables: { region_code: formik.values.region?.code } }}
                    value={formik.values.city}
                    onChange={(e) => {
                        formik.setFieldValue('city', e);
                    }}
                    options={(getCityKecByRegionCodeRes && getCityKecByRegionCodeRes.data
                        && getCityKecByRegionCodeRes.data.getCityKecByRegionCode)
                        || []}
                    loading={getCityKecByRegionCodeRes.loading}
                    primaryKey="value"
                    labelKey="label"
                    fullWidth
                    renderInput={(params) => (
                        <TextField
                            value={formik.values.city}
                            className={classes.textInput}
                            error={!!(formik.touched.city && formik.errors.city)}
                            helperText={(formik.touched.city && formik.errors.city) || ''}
                            {...params}
                        />
                    )}
                    disableClearable
                />
            </div>
            {gmapKey && enableMap ? (
                <div className={classes.boxMap} name="address">
                    <div>
                        <IcubeMapsAutocomplete
                            gmapKey={gmapKey}
                            geocodingKey={geocodingKey}
                            formik={formik}
                            formikName="address"
                            mapPosition={mapPosition}
                            dragMarkerDone={handleDragPosition}
                            customLabel={() => (
                                <InputLabel htmlFor="city" className={classes.label}>
                                    {t('registerseller:Pinpoint_your_Location')}
                                </InputLabel>
                            )}
                            placeholder={t('registerseller:Write_the_name_of_the_street__building__housing')}
                            className={classes.textInputMaps}
                            required
                        />
                    </div>
                </div>
            )
                : (
                    <>
                        <div className={clsx('col-xs-12 col-sm-12', classes.formField)}>
                            <InputLabel htmlFor="longitude" className={[classes.label, classes.required]}>
                                {t('registerseller:Longitude')}
                            </InputLabel>
                            <TextField
                                id="longitude"
                                name="longitude"
                                value={formik.values.longitude}
                                onChange={formik.handleChange}
                                className={classes.textInput}
                                error={!!(formik.touched.longitude && formik.errors.longitude)}
                                helperText={formik.touched.longitude && formik.errors.longitude}
                            />
                        </div>
                        <div className={clsx('col-xs-12 col-sm-12', classes.formField)}>
                            <InputLabel htmlFor="latitude" className={[classes.label, classes.required]}>
                                {t('registerseller:Latitude')}
                            </InputLabel>
                            <TextField
                                id="latitude"
                                name="latitude"
                                value={formik.values.latitude}
                                onChange={formik.handleChange}
                                className={classes.textInput}
                                error={!!(formik.touched.latitude && formik.errors.latitude)}
                                helperText={formik.touched.latitude && formik.errors.latitude}
                            />
                            <div className={classes.textHelper}>
                                <span>
                                    {t('registerseller:Please_check_longitude_and_latitude_from_this')}
                                    {' '}
                                    <a href="https://www.latlong.net/" target="_blank" className={classes.externalLink} rel="noreferrer">
                                        {t('registerseller:site')}
                                    </a>
                                </span>
                            </div>
                        </div>

                    </>
                )}

            <div className={clsx('col-xs-12 col-sm-12', classes.formField)}>
                <InputLabel htmlFor="postcode" className={[classes.label, classes.required]}>
                    {t('registerseller:Postal_Code')}
                </InputLabel>
                <TextField
                    id="postcode"
                    name="postcode"
                    value={formik.values.postcode}
                    onChange={formik.handleChange}
                    className={classes.textInput}
                    error={!!(formik.touched.postcode && formik.errors.postcode)}
                    helperText={(formik.touched.postcode && formik.errors.postcode) || ''}
                />
            </div>

            {isEnableTaxPayer
                && (
                    <div className={clsx('col-xs-12 col-sm-12', classes.formField)}>
                        <InputLabel htmlFor="taxpayer_number" className={[classes.label, classes.required]}>
                            {t('registerseller:NPWP')}
                        </InputLabel>
                        <TextField
                            id="taxpayer_number"
                            name="taxpayer_number"
                            value={formik.values.taxpayer_number}
                            onChange={formik.handleChange}
                            className={classes.textInput}
                            error={!!(formik.touched.taxpayer_number && formik.errors.taxpayer_number)}
                            helperText={(formik.touched.taxpayer_number && formik.errors.taxpayer_number) || ''}
                        />
                        <div style={{ height: 10 }} />
                        <DropFile
                            name="taxpayer_file"
                            error={!!(formik.touched.taxpayer_file && formik.errors.taxpayer_file)}
                            helperText={(formik.touched.taxpayer_file && formik.errors.taxpayer_file) || ''}
                            getBase64={(file) => handleDropFile(file, 'taxpayer_file')}
                            formatFile=".jpg, .jpeg, .png"
                            t={t}
                        />
                    </div>
                )}

            {isEnableID
                && (
                    <div className={clsx('col-xs-12 col-sm-12', classes.formField)}>
                        <InputLabel htmlFor="id_card_number" className={[classes.label, classes.required]}>
                            {t('registerseller:KTP')}
                        </InputLabel>
                        <TextField
                            id="id_card_number"
                            name="id_card_number"
                            value={formik.values.id_card_number}
                            onChange={formik.handleChange}
                            className={classes.textInput}
                            error={!!(formik.touched.id_card_number && formik.errors.id_card_number)}
                            helperText={(formik.touched.id_card_number && formik.errors.id_card_number) || ''}
                        />
                        <div style={{ height: 10 }} />
                        <DropFile
                            name="id_card_file"
                            error={!!(formik.touched.id_card_file && formik.errors.id_card_file)}
                            helperText={(formik.touched.id_card_file && formik.errors.id_card_file) || ''}
                            getBase64={(file) => handleDropFile(file, 'id_card_file')}
                            formatFile=".jpg, .jpeg, .png"
                            t={t}
                        />
                    </div>
                )}

            <div className={clsx('col-xs-12 col-sm-12', classes.formField)}>
                <FormControlLabel
                    control={(
                        <Checkbox
                            checked={termAgree}
                            name="termAgree"
                            onChange={(e) => setTermAgree(e.target.checked)}
                        />
                    )}
                    label={(
                        <span>
                            {t('registerseller:I_agree_to_the')}
                            {' '}
                            <a className={classes.termsCondition} href="/seller-registration-tnc" target="_blank">{t('register:terms_and_conditions')}</a>
                            {' '}
                            {t('registerseller:and_the')}
                            {' '}
                            <a className={classes.termsCondition} href="/seller-registration-privacy-policy" target="_blank">
                                {t('register:privacy_policy')}
                            </a>
                        </span>
                    )}
                    className={classes.controlLabel}
                />

            </div>
            {recaptcha.enable
                && (
                    <div className={clsx('col-xs-12 col-sm-12', classes.formField, classes.recaptcha)}>
                        <ReCAPTCHA
                            sitekey={sitekey}
                            onChange={onReCAPTCHAChange}
                            ref={recaptchaRef}
                            onErrored={() => formik.setFieldValue('captcha', '')}
                            onExpired={() => formik.setFieldValue('captcha', '')}
                        />
                    </div>
                )}
        </>
    );
};

export default RegisterSeller;
